import { Col, Row } from "antd";
import moment from "moment";
import { ReactComponent as Logo } from "shared/assets/images/logo-strm.svg";
import "./ExportProfile.scss";

interface ExportProfilePageProps {
  id: string;
  page: number;
  artistName?: string;
  className: string;
  title: string;
}

const ExportProfilePage: React.FC<ExportProfilePageProps> = (props) => {
  const { children, id, page, artistName, className, title } = props;

  return (
    <div
      id={id}
      className={`export-page ${className}`}
      style={{
        padding: 32,
        height: 1754,
        width: 1240,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Row>
        <Col xs={24}>
          <Row justify="space-between">
            <Col xs={4}>
              <Logo className="logo" height={70} />
            </Col>
            <Col xs={12} style={{ textAlign: "center" }}>
              <h1 className="title-artist-profile">{title} - Strm</h1>
              {artistName && (
                <h3 className="subtitle-artist-profile">{artistName}</h3>
              )}
            </Col>
            <Col xs={4} style={{ textAlign: "end" }}>
              {moment().format("DD/MM/YYYY")}{" "}
            </Col>
          </Row>
        </Col>
        <Col xs={24} className="container">
          {children}
        </Col>
      </Row>
      <Row justify="end">
        <Col xs={4} style={{ textAlign: "end" }}>
          {page}
        </Col>
      </Row>
    </div>
  );
};

export default ExportProfilePage;
